import React, { FC } from 'react';

interface OrganisationToggleProps {
  on: boolean;
  disabled?: boolean;
  label: string;
  onChange: (on: boolean) => void;
}

/** On/off switch used by the organisation console (same look as Team Assistants). */
const OrganisationToggle: FC<OrganisationToggleProps> = ({
  on,
  disabled,
  label,
  onChange,
}) => (
  <button
    type='button'
    role='switch'
    aria-checked={on}
    aria-label={label}
    className={`organisation-toggle${on ? ' on' : ''}`}
    disabled={disabled}
    onClick={() => onChange(!on)}
  >
    <span className='organisation-toggle-knob' />
  </button>
);

export default OrganisationToggle;
